const showAuthModal = () => {
  if (!document) return;
  const authBtnListener = document.getElementById('b2b-auth-show');
  authBtnListener.click();
};

const closeAuthModal = () => {
  if (!document) return;
  const authBtnListener = document.getElementById('b2b-auth-close');
  authBtnListener.click();
};

export default {
  showAuthModal,
  closeAuthModal,
};
